<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>ویرایش اپراتور</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                             <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.name.val" :description="form.name.inv" label="نام" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.regex.val" :description="form.regex.inv" dir="ltr" label="regex" />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_active.val"
                                        :description="form.is_active.inv"
                                        label="وضعیت"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_active.val=$event.target.value"
                                    />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> ویرایش</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import validator from '../mixins'
export default {
    mixins: { validator },
    data() {
        return {
            form: {
				name: {val: '', inv: '', v: { req: true, max: 64 }},
                regex: {val: '', inv: '', v: { req: true, max: 64 }},
                is_active: {val: '', inv: '', v: { req: true, max: 8 }},
			},
            disable: false,
        }
    },
    mounted(){
        this.get_operator();
    },
    methods: {
        get_operator(){
            this.axios.get('mobile_operators/'
                + '?id=' + this.$route.params.id)
                .then(res => {
                    for(const key in res.data[0]){
                        for(const k in this.form){
                            if(key == k){
                                if(key == 'is_active'){
                                    this.form[k].val = `${res.data[0][key]}`;
                                } else {
                                    this.form[k].val = res.data[0][key];
                                }
                            }
                        }
                    }
                })
        },
        submit(){
            if(this.disable == false){
                const data = new FormData();
                for (const key in this.form){
                    data.set(key, this.form[key].val);
                }
                this.axios.put('mobile_operators/', data)
                    .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'ویرایش با موفقیت انجام شد.'
                        });
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        }
    },
	beforeCreate(){
        if(this.$store.state.perms.can_update_mobile_operators == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
